import { defineStore, Store } from 'pinia';
import { ModelsRequestFilter } from '@/types/model/models.type.ts';

export const useModelsFilterStore = (brandId: number): Store<string, ModelsRequestFilter> => {
    return defineStore('models.filters.brand-' + brandId, {
        state: (): ModelsRequestFilter => ({
            brand_id: undefined,
            name: '',
            status: undefined,
            page: 1,
            sort: [{ name: 'asc' }],
        }),
    })();
};
